import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/tailwind.css';
import router from './router';
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
// import 'ionicons/css/ionicons.css';
import { IonicVue } from '@ionic/vue';
import { initPro } from '@/composables/usePro';
// import { IonIcon, addIcons, getIcon } from 'ionicons';
// import './registerServiceWorker';
// import { StatusBar, Style } from '@capacitor/status-bar';

// StatusBar.setOverlaysWebView({ overlay: true });
// StatusBar.setStyle({ style: Style.Dark });

// Define the feature flag globally
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

// addIcons({
//   'arrow-forward': getIcon('arrow-forward'),
// });

import { defineCustomElements } from '@ionic/pwa-elements/loader';
// import { initializeAdMob } from '../../extra/extraComponents/services/admob';
defineCustomElements(window);
// document.addEventListener('deviceready', initializeAdMob);


const app = createApp(App)
.use(IonicVue)  
.use(router)

router.isReady().then(async () => {
  console.log('Router is ready');
  // app.component('IonIcon', IonIcon);
  app.mount('#app');
  await initPro();
});
